import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import styled from '@emotion/styled'
import { DESKTOP_BREAKPOINT } from '@xfers/design-system'
import { XfersLogo, XfersSandboxLogo } from '@xfers/design-system/es/logos'
import faqIcon from './faq.svg'
import hamburgerIcon from './hamburger.svg'
import { createGaEvent } from '~/helpers/gaHelper'
import { ELEVATIONS } from '~/common/elevation'
import MobileNavigation from './MobileNavigation'
import UserProfile from './UserProfile'
import Notifications from './Notifications'
import { USER_ROLES } from '~/types'

type UserInfoBarType = {
  isSandbox: boolean
  userInfo: {
    fullName: string
    avatarUrl: string
    displayname: string
  }
  role?: USER_ROLES | null
  notifications: {
    data: {
      id: number
      title: string
      message: string
      created_at: string
      is_read: number
      external_link: string
    }[]
    unreadCount: number
    isLoading: boolean
  }
  switchSandbox?: (sandboxMode: boolean) => void
}

export default function({
  isSandbox,
  userInfo,
  notifications,
  switchSandbox,
  role,
}: UserInfoBarType) {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false)

  const whiteOrBlue = () => {
    return isSandbox ? '#2c4058' : 'white'
  }

  return (
    <>
      <DesktopView>
        <a
          href="https://xfershelp.zendesk.com/hc/en-us"
          rel="noopener noreferrer"
          target="_blank"
          onClick={() =>
            createGaEvent('General', 'clickFaqQuestionMarkLogoLink', 'Clicked FAQ ? Logo')
          }
        >
          <FaqImg src={faqIcon} />
        </a>
        <Notifications notifications={notifications} />
        <UserProfile
          userInfo={userInfo}
          isSandbox={isSandbox}
          switchSandbox={switchSandbox}
          role={role}
        />
      </DesktopView>
      <MobileView style={{ background: whiteOrBlue() }}>
        <HamburgerButton
          onClick={() => {
            setIsMobileNavOpen(true)
            createGaEvent(
              'General',
              'clickMobileHamburgerLogoLink',
              'Clicked Mobile Hamburger Logo'
            )
          }}
        >
          <img src={hamburgerIcon} />
        </HamburgerButton>
        <MobileRightSection>
          <Notifications notifications={notifications} />
          <UserProfile
            userInfo={userInfo}
            isSandbox={isSandbox}
            switchSandbox={switchSandbox}
            role={role}
          />
        </MobileRightSection>
        <Link
          to="/"
          style={{
            position: 'absolute',
            top: '0px',
            left: '50%',
          }}
        >
          <MobileLogo>
            {isSandbox ? (
              <XfersSandboxLogo width={145} height={20} />
            ) : (
              <XfersLogo width={85} height={30} />
            )}
          </MobileLogo>
        </Link>
      </MobileView>
      <MobileNavigation
        isSandbox={isSandbox}
        isOpen={isMobileNavOpen}
        onClose={() => setIsMobileNavOpen(false)}
      />
    </>
  )
}

const DesktopView = styled.div`
  display: none;
  height: 73px;
  border-bottom: 1px solid #e8e8e8;
  justify-content: flex-end;
  align-items: center;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #1b2736;
  padding-right: 26px;

  ${DESKTOP_BREAKPOINT} {
    display: flex;
  }
`

const MobileView = styled.div`
  display: flex;
  height: 73px;
  border-bottom: 1px solid #e8e8e8;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  top: 0;
  background: white;
  z-index: ${ELEVATIONS.FLOATING_NAVIGATION_BAR};

  ${DESKTOP_BREAKPOINT} {
    display: none;
  }
`

const MobileRightSection = styled.div`
  display: flex;
  padding-right: 6px;
`

const FaqImg = styled.img`
  margin-right: 30px;
  cursor: pointer;
`

const HamburgerButton = styled.div`
  width: 53px;
  height: 45px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

const MobileLogo = styled.div`
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
`
